import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TableCell, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import qs from 'query-string';
import { Collector, CollectorSettingScope } from 'graphql/types';
import { collectorUninstall, isWithinAnotherApp } from 'containerApp';

const useStyles = makeStyles((theme) => ({
  disconnectLink: {
    opacity: '0.6',
    color: theme.palette.grey[600]
  }
}));
type DisconnectCellProps = {
  scope: CollectorSettingScope;
  info: Collector | undefined;
  isAdmin: boolean;
  installId: string;
};

export const DisconnectCell: React.FC<DisconnectCellProps> = ({
  scope,
  info,
  isAdmin,
  installId
}: DisconnectCellProps) => {
  const classes = useStyles();
  const enabled = isAdmin || scope === CollectorSettingScope.User;
  const disconnectColor = enabled ? 'primary' : 'inherit';

  const handleDisconnect = useCallback(
    (collector) => {
      const query = qs.stringify({
        id: collector.id,
        scope: scope
      });
      const { origin } = window.location;
      const url = `${origin}/collector/uninstall?${query}`;
      if (isWithinAnotherApp()) {
        collectorUninstall(url);
      } else {
        window.open(`/collector/uninstall?${query}`);
      }
    },
    [scope]
  );

  const onDisconnect = useCallback((info) => () => handleDisconnect(info), [
    handleDisconnect
  ]);

  return (
    <TableCell>
      <Link
        className={enabled ? '' : classes.disconnectLink}
        onClick={enabled ? onDisconnect(info) : undefined}
        href={enabled ? '#installed' : undefined}
        color={disconnectColor}
        underline="none"
        data-testid={`uninstall-link-${installId}`}
        role="link"
        aria-disabled={!enabled}
      >
        <FormattedMessage id="collectorSetting.uninstall" />
      </Link>
    </TableCell>
  );
};
export default React.memo(DisconnectCell);
